<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <img src="./assets/img/images/expired.svg" width="64" alt="no match" />
    </div>
    <h1 class="title-copy">{{ 'Policy linked to another account' | translate }}</h1>
  <ng-container *ngIf="user?.policyDetail?.length !== 6">
  <div class="sub-title-copy lowercase">
    {{ 'Policy is linked to the following email' | translate }}
  </div>
  <div class="sub-title-copy lowercase">
    {{ 'Do you recognize it?' | translate }}
  </div>
  <div class="sub-title-copy margin-vertical mv16">
    <strong>{{ message }}</strong>
  </div>
  <div class="margin-vertical mv16">
    <mapfre-button additionalClasses="basic primary large full no-margin" [routerLink]="['/login']"
      [translateValue]=" 'LOGIN' | translate ">
      {{ 'LOGIN' | translate }}
    </mapfre-button>
  </div>
  <hr class="margin-vertical mv16"/>
</ng-container>
</div>
</div>
<div class="row text-center">
  <div class="col">
<div class="grey-color">
  {{ 'Review your policy details' | translate }}
</div>
</div>
</div>
<div>
  <app-policy-linked-to-another-email-screens></app-policy-linked-to-another-email-screens>
</div>